var _style, _g, _defs, _defs2, _rect, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 320 320",
    style: {
      enableBackground: "new 0 0 320 320"
    },
    xmlSpace: "preserve",
    fill: "#9ca4ad",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{opacity:0.3;fill:none;stroke:#4698CA;enable-background:new    ;}\r\n\t.st3{fill:none;stroke:#4698CA;}\r\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;}\r\n\t.st5{fill:#FFFFFF;}\r\n\t.st6{fill:none;}\r\n\t.st7{fill:#020301;}\r\n\t.st8{clip-path:url(#SVGID_2_);}\r\n\t.st9{clip-path:url(#SVGID_4_);}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "grid",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 30,
    y1: 0,
    x2: 30,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 60,
    y1: 0,
    x2: 60,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 70,
    y1: 0,
    x2: 70,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 80,
    y1: 0,
    x2: 80,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 90,
    y1: 0,
    x2: 90,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 100,
    y1: 0,
    x2: 100,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 110,
    y1: 0,
    x2: 110,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 120,
    y1: 0,
    x2: 120,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 130,
    y1: 0,
    x2: 130,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 140,
    y1: 0,
    x2: 140,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 150,
    y1: 0,
    x2: 150,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 160,
    y1: 0,
    x2: 160,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 170,
    y1: 0,
    x2: 170,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 180,
    y1: 0,
    x2: 180,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 190,
    y1: 0,
    x2: 190,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 200,
    y1: 0,
    x2: 200,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 210,
    y1: 0,
    x2: 210,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 220,
    y1: 0,
    x2: 220,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 230,
    y1: 0,
    x2: 230,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 240,
    y1: 0,
    x2: 240,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 250,
    y1: 0,
    x2: 250,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 260,
    y1: 0,
    x2: 260,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 270,
    y1: 0,
    x2: 270,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 280,
    y1: 0,
    x2: 280,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 290,
    y1: 0,
    x2: 290,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 300,
    y1: 0,
    x2: 300,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 310,
    y1: 0,
    x2: 310,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 10,
    x2: 320,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 20,
    x2: 320,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 30,
    x2: 320,
    y2: 30
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 40,
    x2: 320,
    y2: 40
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 50,
    x2: 320,
    y2: 50
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 60,
    x2: 320,
    y2: 60
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 70,
    x2: 320,
    y2: 70
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 80,
    x2: 320,
    y2: 80
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 90,
    x2: 320,
    y2: 90
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 100,
    x2: 320,
    y2: 100
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 110,
    x2: 320,
    y2: 110
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 120,
    x2: 320,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 130,
    x2: 320,
    y2: 130
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 140,
    x2: 320,
    y2: 140
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 150,
    x2: 320,
    y2: 150
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 160,
    x2: 320,
    y2: 160
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 170,
    x2: 320,
    y2: 170
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 180,
    x2: 320,
    y2: 180
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 190,
    x2: 320,
    y2: 190
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 200,
    x2: 320,
    y2: 200
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 210,
    x2: 320,
    y2: 210
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 220,
    x2: 320,
    y2: 220
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 230,
    x2: 320,
    y2: 230
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 240,
    x2: 320,
    y2: 240
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 250,
    x2: 320,
    y2: 250
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 260,
    x2: 320,
    y2: 260
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 270,
    x2: 320,
    y2: 270
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 280,
    x2: 320,
    y2: 280
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 290,
    x2: 320,
    y2: 290
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0,
    y1: 300,
    x2: 320,
    y2: 300
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 310,
    x2: 320,
    y2: 310
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M-166.4-115.3c-3.4-2.1-8.5-6-14.5-10.7c7.7-5.8,15.1-11.4,21.2-16c7.6,8.4,14.4,14.7,20.7,19.1 l-18.8,12.8L-166.4-115.3z M-253.9-248.3c3.1,3.7,8.5,8.6,17.4,12.7c-1.4,1-2.9,2-4.2,3c-3.8,2.8-8.9,6.5-14.6,10.8 c-9.1-2.7-16.3-7.4-20.9-11.2L-253.9-248.3z M-158.3-158.6c-6.8-8.2-14.3-18-22.7-30c-1.5-2.1-2.9-4-4.2-5.8 c6.1-7.7,12.8-12.1,23.3-13.1c0.2,0.3,0.4,0.5,0.5,0.8c6.5,9.9,14.6,22.1,24.7,33.7c-8.6,5.2-14.6,9-17,10.9 C-154.7-161.3-156.3-160.1-158.3-158.6z M-222.2-158.5c-7.1-5.3-14.2-10.2-20.9-14.3c3.2-4.1,6.2-8.6,8.9-13.7l0.7-1.4 c4-7.6,7.5-14,11-19.5c7.2,0,13,2.3,22.6,13.5c-2.6,4.1-5.1,8.5-7.8,13.2c-1.7,2.9-3.5,6-5.4,9.3 C-215.9-166.7-219-162.4-222.2-158.5z M-229.8-220.1c-2.3,0.2-4.9,0.3-7.7,0.4c0.8-0.6,1.7-1.2,2.4-1.8c4.1-3,8.8-6.1,13.8-9.2 c0.8,0.2,1.6,0.3,2.5,0.5c-3.3,2.9-6.2,6.2-9,10C-228.5-220.2-229.1-220.2-229.8-220.1z M-154.5-220.8c-0.8,0-1.6,0-2.3,0 c-2.3-3.5-4.5-6.5-6.5-9.1c0.6-0.1,1.1-0.2,1.7-0.4c5.4,3.5,10.4,6.7,15,9.7C-149-220.6-151.6-220.7-154.5-220.8z M-174.8-224.9 c1.4,1.3,3,3.3,4.7,5.6c-9.6,2.5-16.6,8-22.7,15.5c-7.9-9.1-14-13.5-20.2-15.4c6.8-6.2,15.1-9.6,27.9-10.2 C-181.2-228.7-177.5-227.4-174.8-224.9z M-148-207.5c7.7,0.2,13.8-0.1,19.2-1.1c0.4,0.3,0.8,0.6,1.1,0.8 c2.2,1.7,10.7,8.5,20.9,16.4c-6.8,4.2-13.6,8.4-19.6,12C-134.8-188.4-141.9-198.3-148-207.5z M-114.7-213.2 c5.8-3,11.9-7.5,19.7-13.9l21.2,14.5c-5.5,4-13.3,9.1-21.8,14.4C-102-203.2-108.6-208.4-114.7-213.2z M-126.8-222.4 c-4.8-3.3-11.9-8-20.1-13.3c5.9-2.9,12.7-7.2,19.8-13.3l21.4,14.6C-113.9-227.9-119.9-224.3-126.8-222.4z M-160-244.2 c-6.4-4.1-13-8.3-19.4-12.4c7.1-4.7,13.7-9.6,19.7-14.7l22.1,15C-146.5-249.5-154.3-246-160-244.2z M-180.7-242.5 c-1.4,0-2.7,0-4,0.1c-8.3-1.1-15.9,0.4-18.3,0.9c-0.2,0-0.3,0-0.5,0c4.2-2.5,8.3-5,12.4-7.6 C-187.6-246.9-184.1-244.7-180.7-242.5z M-210.8-251.8c-4.1,2.5-8.2,4.9-12.1,7.3c-10.7-2.9-17.3-7.3-21-10.7l20.7-14.1 c6,3.8,12.9,8.1,20.2,12.7C-205.5-255-208.1-253.4-210.8-251.8z M-267.6-212.8c-6.1,4.5-12.4,9.3-18.5,13.9 c-8.1-5.2-15.2-10-20.4-13.5l19.9-13.5C-283.1-222.5-276.6-217.1-267.6-212.8z M-253.5-207.9c2.9,0.6,6,1.1,9.2,1.3 c2.9,0.1,5.5,0.1,7.9,0.1c-2.1,3.6-4.1,7.5-6.3,11.6l-0.7,1.4c-3,5.6-6.4,10.5-10.1,14.8c-7-4-14.3-8.5-21.5-13 C-267.7-197.3-260.2-202.8-253.5-207.9z M-262.7-169.5c-10.2,8.9-20,13.6-24.2,15.4l-20.1-13.7c5.3-4,12.8-9.6,21.2-15.9 C-278.3-179-270.3-174-262.7-169.5z M-251.6-163.2c6.6,3.7,13.7,8.5,21,13.8c-9.7,9.5-19,15.3-23.2,17.7l-20.9-14.3 C-268.3-149.4-259.9-155-251.6-163.2z M-220.9-142c6.8,5.2,13.6,10.6,19.8,15.7c-9.3,7-17.4,13.1-21.4,16.1l-20.1-13.7 C-236.6-127.8-228.8-133.8-220.9-142z M-191.6-134.5c-6.6-5.3-13.8-11.1-21.1-16.8c3-3.8,5.9-7.9,8.5-12.4 c1.9-3.3,3.8-6.4,5.5-9.4c2.3-4,4.4-7.6,6.4-10.9c0.9,1.3,1.9,2.6,2.9,4c7.9,11.2,15,20.6,21.6,28.6 c-6.7,5.1-14.9,11.3-23.1,17.4C-191.1-134.2-191.3-134.3-191.6-134.5z M-150.2-149.2c1-0.7,1.7-1.3,2.3-1.7 c2.3-1.8,10.2-6.6,20-12.6c2.3,2.3,4.7,4.5,7.3,6.6c0.3,0.3,6.4,6.2,14.5,11.6l-21.5,14.7C-134.3-134-141.6-140-150.2-149.2z  M-114.1-167.4c-1.1-0.9-2-1.8-3.1-2.7c7.4-4.5,14.5-8.9,21-12.9c7.9,6.1,15.7,12,21.6,16.2l-20.1,13.7 C-104.8-158.5-113.7-167-114.1-167.4z M-85-190.1c9.6-6.2,17.2-11.4,22-15.3l22.5,15.4l-23.1,15.7 C-67.4-176.8-75.4-182.8-85-190.1z M-170.2-278.4c-6.3,5-13.4,9.8-20.8,14.5c-8.2-5.2-15.4-9.8-20.8-13.1l21.8-14.9L-170.2-278.4 z M-317.7-204.9c3.8,2.6,11.4,7.8,20.8,14c-9.2,6.9-17,12.8-20.9,15.7l-21.7-14.8L-317.7-204.9z M-211.6-102.8 c5.2-4,12.6-9.5,20.6-15.5c8.1,6.5,15,11.9,19.7,14.7l2.2,1.3L-190-88.1L-211.6-102.8z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: -339.5,
    y: -291.9,
    width: 299.4,
    height: 219.5
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -439.3,
    y: -391.7,
    className: "st9",
    width: 498.6,
    height: 403.4
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M36.9,309.5h246.2v-35.2H36.9V309.5z M107.2,10.5V116H36.9L160,239.1L283.1,116h-70.4V10.5H107.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/Icon_Download.9df51305f75cf01ee120e3b5029258bc.svg";
export { ForwardRef as ReactComponent };